import { call, put, takeLatest } from 'redux-saga/effects';

import { filePsmAudit, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';

export function* remove({ payload: { companyId, id } }) {
  try {
    yield call(dataProvider.deleteList, `companies/${companyId}/psm-audit/${id}`);
    yield put({ type: filePsmAudit.remove.end, payload: { id } });
  } catch (e) {
    yield put({ type: notification.add, payload: { error: e.message } });
    yield put({ type: filePsmAudit.remove.error, payload: { id } });
  }
}

export default function* removeFileSaga() {
  yield takeLatest(filePsmAudit.remove.start, remove);
}
